import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

function UserDetail() {
  const { id } = useParams();
  const navigate = useNavigate(); // ✅ correct place

  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch(`https://jsonplaceholder.typicode.com/users/${id}`)
      .then(res => res.json())
      .then(data => setUser(data));
  }, [id]);

  if (!user) return <p>Loading...</p>;

  return (
    <div className="detail-container">

      {/* 🔥 Back Button */}
      <button 
        onClick={() => navigate(-1)} 
        style={{
          marginBottom: "15px",
          padding: "8px 12px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer"
        }}
      >
        ⬅ Back
      </button>

      <div className="detail-header">
        <h2>{user.name}</h2>
      </div>

      <div className="section">
        <h3>Basic Info</h3>
        <p className="detail-item"><span>Email:</span> {user.email}</p>
        <p className="detail-item"><span>Phone:</span> {user.phone}</p>
        <p className="detail-item"><span>Username:</span> {user.username}</p>
        <p className="detail-item"><span>Website:</span> {user.website}</p>
      </div>

      <div className="section">
        <h3>Company</h3>
        <p className="detail-item">{user.company.name}</p>
        <p className="detail-item">{user.company.catchPhrase}</p>
      </div>

      <div className="section">
        <h3>Address</h3>
        <p className="detail-item">{user.address.street}</p>
        <p className="detail-item">{user.address.city}</p>
        <p className="detail-item">{user.address.zipcode}</p>
      </div>

    </div>
  );
}

export default UserDetail;